import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'hooks';

import { setForgotPasswordStep } from 'features/forgotPassword/forgotPasswordSlice';

import { Paper } from 'componets/ui';
import { ForgotPasswordRecovery } from './ForgotPasswordRecovery';
import { ForgotPasswordCheckEmail } from './ForgotPasswordCheckEmail';
import { ForgotPasswordUpdated } from './ForgotPasswordUpdated';
import { RegistrationLayout } from 'componets/layouts';

import s from './index.module.scss';

export const ForgotPassword: FC = () => {
	const step = useAppSelector((state) => state.forgotPassword.step);

	const dispatch = useDispatch();

	let Component = ForgotPasswordRecovery;

	switch (step) {
		case 4:
			Component = ForgotPasswordUpdated;
			break;
		case 2:
			Component = ForgotPasswordCheckEmail;
			break;
	}

	useEffect(() => {
		return () => {
			dispatch(setForgotPasswordStep(1));
		};
	}, [dispatch]);

	return (
		<RegistrationLayout>
			<Paper styleName={s.forgotPassword}>
				<Component />
			</Paper>
		</RegistrationLayout>
	);
};
